var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3561_6135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 6.89543 2.89543 6 4 6H12C13.1046 6 14 6.89543 14 8V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V8Z",
    stroke: "#008cff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97216 5.15066C2.50308 5.44218 2.35914 6.05877 2.65066 6.52784C2.94218 6.99692 3.55877 7.14086 4.02784 6.84934L2.97216 5.15066ZM4.02784 6.84934L10.5454 2.79886L9.48968 1.10018L2.97216 5.15066L4.02784 6.84934ZM10.5454 2.79886V6H12.5454V2.79886H10.5454ZM10.5454 2.79886L10.5454 2.79886H12.5454C12.5454 1.23027 10.8219 0.272206 9.48968 1.10018L10.5454 2.79886Z",
    fill: "#008cff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 1,
    fill: "#008cff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3561_6135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIconBlue);
export default __webpack_public_path__ + "static/media/PriceIconBlue.5d11513e9ceced33849b788780a5c97e.svg";
export { ForwardRef as ReactComponent };